import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app.js';
import { ConfigUnavailableError, loadConfig } from './config.js';
import { FatalError } from './ui/states.js';
import './styles.css';

/**
 * Bootstrap (M1.14.1).
 *
 * The configuration is fetched *before* anything renders, because every part
 * of the application needs it — the API's base URL and the Cognito pool — and
 * a tree that renders first and discovers later would need a "not configured
 * yet" branch in every component.
 *
 * A missing configuration is a real state, not a crash. After
 * [D22](../../Design-Decisions.md) this client survives a teardown of the
 * backend, so being served without a reachable API is expected at alpha and
 * the page says so.
 */

const root = createRoot(document.getElementById('root') as HTMLElement);

loadConfig()
  .then((config) => {
    root.render(
      <StrictMode>
        <App config={config} />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    root.render(
      <FatalError
        detail={
          error instanceof ConfigUnavailableError
            ? error.detail
            : 'The application could not start.'
        }
      />,
    );
  });
